const {registerBlockType} = wp.blocks;
const {MediaUpload, MediaUploadCheck, RichText, URLInputButton} = wp.blockEditor;
const {Button} = wp.components;
const {useEffect} = wp.element;

import { homeAccordion } from '../../../resources/scripts/module/accordion';

registerBlockType('mailmetrics/accordion', {
  title: 'Accordion',
  icon: 'welcome-add-page',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    mainHeading: {
      type: 'string',
      default: 'Three big things we do for business'
    },
    captionText: {
      type: 'string',
      default: 'we help you'
    },
    accordionItems: {
      type: 'array',
      default: [],
    },
    activeItemIndex: {
      type: 'number',
      default: 0
    },
  },

  edit: ({attributes, setAttributes}) => {
    const {accordionItems, mainHeading, captionText, activeItemIndex} = attributes;
    const sectionClass = 'section-accordion-' + (new Date()).getTime();

    useEffect(() => {
      homeAccordion('home');

      return () => {
      };
    }, [accordionItems]);

    useEffect(() => {
      const activeItem = accordionItems[activeItemIndex];
      const imageElement = document.querySelector(`.${sectionClass} .accordion-content-image`);
      if (imageElement && activeItem) {
        imageElement.src = activeItem.imageUrl;
      }
    }, [accordionItems, activeItemIndex]);

    const handleAddItem = () => {
      const newItems = [...accordionItems, {header: '', content: '', url: '', urlText: '', imageId: 0, imageUrl: ''}];
      setAttributes({accordionItems: newItems});
    };

    const handleRemoveItem = (index) => {
      const newItems = accordionItems.filter((_, i) => i !== index);
      setAttributes({accordionItems: newItems});

      if (newItems.length === 0) {
        const imageElement = document.querySelector(`.${sectionClass} .accordion-content-image`);
        if (imageElement) {
          imageElement.src = '';
        }
      }
    };

    const updateItem = (index, newData) => {
      const newItems = accordionItems.map((item, i) => (i === index ? {...item, ...newData} : item));
      setAttributes({accordionItems: newItems});

      document.querySelector(`.${sectionClass} .accordion-content-image`).src = newData.imageUrl;
    };

    const toggleActiveItem = (index) => {
      setAttributes({activeItemIndex: index});

      const activeItem = accordionItems[index];
      const imageElement = document.querySelector(`.${sectionClass} .accordion-content-image`);
      if (imageElement && activeItem) {
        imageElement.src = activeItem.imageUrl;
      }
    };

    return (
      <div className={`accordion-section ${sectionClass}`}>
        <div className="inner">
          <div>
            <div className="section-header">
              <RichText
                tagName="h1"
                value={mainHeading}
                onChange={(newText) => setAttributes({mainHeading: newText})}
                placeholder="Enter main heading..."
              />
            </div>
            <div className="section-content">
              <div className="accordion-image">
                <img className="accordion-content-image" src="" alt=""/>
              </div>
              <div className="accordion-wrapper">
                <RichText
                  tagName="span"
                  className="caption"
                  value={captionText}
                  onChange={(newText) => setAttributes({captionText: newText})}
                  placeholder="Enter caption..."
                />
                <div data-accordion="home" className="accordion-container">
                  {accordionItems.map((item, index) => (
                    <>
                      <div data-img={item.imageUrl}
                           className={`accordion-item ${index === activeItemIndex ? 'accordion-item-active' : ''}`}>
                        <button className={"accordion-header"} onClick={() => toggleActiveItem(index)}>
                          <RichText
                            tagName="h4"
                            value={item.header}
                            onChange={(newHeader) => updateItem(index, {header: newHeader})}
                            placeholder="Enter item name..."
                          />
                        </button>
                        <div className="accordion-content">
                          <RichText
                            tagName="p"
                            value={item.content}
                            onChange={(newContent) => updateItem(index, {content: newContent})}
                            placeholder="Enter content..."
                          />
                          <a href={'#'} className={'accordion-content-url'} title={item.url}>
                            <RichText
                              tagName="span"
                              value={item.urlText}
                              onChange={(newLinkText) => updateItem(index, {urlText: newLinkText})}
                            />
                            <URLInputButton
                              url={item.url}
                              onChange={(newUrl) => updateItem(index, {url: newUrl})}
                            />
                          </a>
                        </div>
                        <br/>
                        <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(media) => updateItem(index, {imageId: media.id, imageUrl: media.url})}
                            allowedTypes={['image']}
                            value={item.imageId}
                            render={({open}) => (
                              <Button onClick={open} isDefault>
                                {!item.imageId ? 'Select Image' : 'Replace Image'}
                              </Button>
                            )}
                          />
                        </MediaUploadCheck>
                        <Button isDestructive onClick={() => handleRemoveItem(index)}>
                          Remove Item
                        </Button>
                      </div>
                      <hr/>
                    </>
                  ))}
                  <Button isPrimary onClick={handleAddItem}>
                    Add Accordion Item
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },

  save: ({attributes}) => {
    const {accordionItems, mainHeading, captionText, activeItemIndex} = attributes;

    const activeItem = accordionItems[activeItemIndex];

    return (
      <div className="accordion-section">
        <div className="inner">
          <div>
            <div className="section-header">
              <RichText.Content
                tagName="h1"
                value={mainHeading}
              />
            </div>
            <div className="section-content">
              <div className="accordion-image">
                <img className="accordion-content-image" src={activeItem.imageUrl} alt=""/>
              </div>
              <div className="accordion-wrapper">
                <RichText.Content
                  tagName="span"
                  className={'caption'}
                  value={captionText}
                />
                <div data-accordion="home" className="accordion-container">
                  {accordionItems.map((item, index) => (
                    <>
                      <div data-img={item.imageUrl}
                           className={`accordion-item ${index === activeItemIndex ? 'accordion-item-active' : ''}`}>
                        <button className={`accordion-header`}>
                          <RichText.Content
                            tagName="h4"
                            value={item.header}
                          />
                        </button>
                        <div className="accordion-content">
                          <RichText.Content
                            tagName="p"
                            value={item.content}
                          />
                          {item.url && <a className="accordion-content-url" href={item.url}>
                            <RichText.Content
                              tagName="span"
                              value={item.urlText}
                            />
                          </a>
                          }
                        </div>
                      </div>
                      <hr/>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
